import { HallowABFlag } from "./HallowABFlag.enum";

export const MixpanelABFlagValidProps = {
  [HallowABFlag.WebAdventShortOnboarding]:
    HallowABFlag.WebAdventShortOnboarding,
  [HallowABFlag.WebAppDownloadScreen]: HallowABFlag.WebAppDownloadScreen,
  [HallowABFlag.WebFamilyPlanUpgradeAdvent]:
    HallowABFlag.WebFamilyPlanUpgradeAdvent,
  [HallowABFlag.FamilyPlanOneClickUpgrade]: "family_plan_upgrade_valid",
  [HallowABFlag.WebMediumOnboarding]: "web_medium_onboarding_valid",
  [HallowABFlag.WebOnboardingSmsPrompt]: HallowABFlag.WebOnboardingSmsPrompt,
  [HallowABFlag.WebLentOnboarding]: HallowABFlag.WebLentOnboarding,
  [HallowABFlag.WebKidsProfileLaunch]: HallowABFlag.WebKidsProfileLaunch,
} as const;
